const adminStatic = [
	"dashboard:view",
	"drawer-admin-items:view",
	"tickets-manager:showall",
	"user-modal:editProfile",
	"user-modal:editQueues",
	"ticket-options:deleteTicket",
	"contacts-page:deleteContact",
	"connections-page:actionButtons",
	"connections-page:addConnection",
	"connections-page:editOrDeleteConnection",
	"tickets-manager:closeAll",
];

const rules = {
	user: {
		static: [],
	},

	admin: {
		static: adminStatic,
	},

	superadmin: {
		static: adminStatic,
	},
};

export default rules;
